var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29878 18L7.33638 17.4893L8.13618 14.5919C6.93899 14.1635 5.82634 13.5393 4.84654 12.7463L2.65854 14.8699L1.22053 13.4749L3.40955 11.3523C2.17386 9.91662 1.34359 8.19431 1 6.35393L3 6C3.77134 10.1426 7.50711 13.2856 12 13.2856C16.4919 13.2856 20.2287 10.1426 21 6L23 6.35294C22.6569 8.19358 21.827 9.91624 20.5915 11.3523L22.7795 13.4749L21.3415 14.8699L19.1535 12.7463C18.1737 13.5393 17.061 14.1635 15.8638 14.5919L16.6636 17.4903L14.7012 18L13.9004 15.1015C12.6426 15.3106 11.3574 15.3106 10.0996 15.1015L9.29878 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseEye);
export default __webpack_public_path__ + "static/media/icon_close_eye.a1beca8859491d51639e15221a1f79ea.svg";
export { ForwardRef as ReactComponent };